import { Injectable, Injector } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { CORE_ACTIONS } from "@ispm/core/constants/core-actions.constant";
import { EVENT_ACTIONS } from "@ispm-client/modules/events/store/actions/index";
import { Store } from '@ngrx/store';
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";

@Injectable()
export class EventEffects {
  constructor(private actions$: Actions, private store$: Store<IgenomicsState>) { }

  @Effect({ dispatch: false})
  clearingEvents  = this.actions$.pipe(
    ofType(CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS),
    tap(() => {
      this.store$.dispatch({
        type: EVENT_ACTIONS.CLEAR_EVENTS,
        payload: {}
      });

      this.store$.dispatch({
        type: EVENT_ACTIONS.CHANGE_SELECTED_EVENT,
        payload: null
      });

    }));

}
